// Petits éléments de la fiche d'un matériel : lien vers un document, ligne de détail et ligne d'historique.

export function DocumentLink({ url, fileName }) {
    return url ? (
        <a href={url} target="_blank" rel="noreferrer" style={{ color: "#0C3B3C", fontWeight: 800 }}>
            {fileName || "Ouvrir le document"}
        </a>
    ) : <span style={{ color: "#5A6D68" }}>Aucun document</span>;
}

export function DetailLine({ label, value }) {
    return (
        <div style={{ display: "grid", gridTemplateColumns: "132px 1fr", gap: "8px", padding: "8px 0", borderBottom: "1px solid #F1EEE6", fontSize: "13px" }}>
            <span style={{ color: "#5A6D68", fontWeight: 800 }}>{label}</span>
            <span style={{ color: "#122A26", minWidth: 0, fontWeight: 600 }}>{value}</span>
        </div>
    );
}

export function HistoryRow({ text, detail, onDelete }) {
    return (
        <div style={{ border: "1px solid #E1DCCF", borderRadius: "8px", padding: "9px 10px", display: "grid", gridTemplateColumns: "1fr auto", gap: "10px", alignItems: "center", marginBottom: "7px", background: "#FDFCF8" }}>
            <div style={{ minWidth: 0 }}>
                <strong style={{ color: "#122A26", fontSize: "13px" }}>{text}</strong>
                {detail && <div style={{ color: "#5A6D68", fontSize: "12px", marginTop: "3px" }}>{detail}</div>}
            </div>
            <button type="button" onClick={onDelete} style={{ padding: "5px 8px", borderRadius: "8px", border: "1px solid #FCA5A5", background: "#FEF2F2", color: "#B91C1C", cursor: "pointer", fontWeight: 800 }}>
                Supprimer
            </button>
        </div>
    );
}
